import React, { useState } from 'react'

import { capitalizeFirstLetter } from '../../utils/helpers'

const FILTER_QUESTION_ID = 'ab0b4a8e-dd3b-4730-bc4e-f9b363a3adff'

const getFilterData = (dashboardFilters) => {
    const filter = dashboardFilters.find(({ question }) => question === FILTER_QUESTION_ID)
    if (!filter?.options?.length) return null
    const { label, numberOfResponses } = filter.options[0]
    return { label, numberOfResponses }
}

const SegmentSummary = ({ dashboardFilters, data }) => {
    const [filterData] = useState(() => getFilterData(dashboardFilters))

    if (!filterData) return null

    const { label, numberOfResponses } = filterData ?? { label: '', numberOfResponses: 0 }

    const segmentTotals = {}

    Object.entries(data).forEach(([segment, rows]) => {
        Object.values(rows).forEach(({ count }) => {
            segmentTotals[segment] ??= 0
            segmentTotals[segment] += count
        })
    })

    return (
        <div className="EEM-segment-summary">
            <i className="fa-light fa-circle-info" />
            <div>
                <span style={{ fontWeight: 600 }}>{label}</span> left <span style={{ fontWeight: 600 }}>{numberOfResponses} response(s)</span>, mapped across {Object.keys(segmentTotals).length} segment(s)
            </div>
            {Object.entries(segmentTotals).map(([segment, total]) => (
                <div className="EEM-segment-summary__segment">
                    <div className={`EEM-segment-summary__segment__indicator ${segment.toLowerCase()}`} />
                    {capitalizeFirstLetter(segment)}
                    {' '}
                    {total}
                </div>
            ))}
        </div>
    )
}

export default SegmentSummary
